import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=059f9332&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./TheHeader.vue?vue&type=style&index=0&id=059f9332&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "059f9332",
  null
  ,true
)

export default component.exports